import { isLiveSite } from "@/lib/siteConfig";

const CONTACT_FALLBACK = "/contact-us";

// External/mailto/tel/anchor links aren't ours to police — always "live".
function isExternalOrSpecial(href) {
  return /^([a-z][a-z0-9+.-]*:)?\/\//i.test(href) || href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("#");
}

function isLivePath(href, livePaths) {
  if (!href) return false;
  if (isExternalOrSpecial(href)) return true;
  const clean = href.split("?")[0].split("#")[0];
  return livePaths.includes(clean);
}

export function filterLiveLinks(items, livePaths, hrefKey = "href") {
  if (!isLiveSite) return items;
  return items.filter((item) => isLivePath(item[hrefKey], livePaths));
}

export function resolveLiveHref(href, livePaths) {
  if (!isLiveSite) return href;
  return isLivePath(href, livePaths) ? href : CONTACT_FALLBACK;
}

export function filterLiveGroups(groups, livePaths, {
  hrefKey = "href",
  childHrefKey = hrefKey,
  childrenKey = "children",
  dropIfAllDead = true,
  requireParentLive = false,
} = {}) {
  if (!isLiveSite) return groups;
  return groups
    .map((group) => {
      const liveChildren = (group[childrenKey] ?? []).filter((c) => isLivePath(c[childHrefKey], livePaths));
      const parentLive = isLivePath(group[hrefKey], livePaths);
      // A group can opt out of requireParentLive (e.g. its pillar page isn't built yet but children are live).
      if (requireParentLive && !parentLive && !group.allowWithoutParent) return null;
      if (dropIfAllDead && !parentLive && liveChildren.length === 0) return null;
      return {
        ...group,
        [hrefKey]: parentLive ? group[hrefKey] : CONTACT_FALLBACK,
        [childrenKey]: liveChildren,
      };
    })
    .filter(Boolean);
}
